module.exports = __webpack_public_path__ + "img/process-2.66d3289f.png";